<style scoped>
.qrCode {
  position: fixed;
  bottom: 500px;
  right: 2%;
  z-index: 999999999;
  width: 100px;
  height: 120px;
  text-align: center;
  font-size: 10px;
  background: linear-gradient(180deg, #F4F5F7 0%, #FFFFFF 100%);
  box-shadow: 0px 3px 12px 0px rgba(18, 62, 94, 0.15);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #FFFFFF;
}
.floatMenu {
  position: fixed;
  bottom: 200px;
  right: 2.4%;
  z-index: 99999;
  width: 80px;
  background: linear-gradient(180deg, #F4F5F7 0%, #FFFFFF 100%);
  box-shadow: 0px 3px 12px 0px rgba(18, 62, 94, 0.15);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #FFFFFF;
  text-align: center;
  overflow: hidden;
  cursor: pointer;
  font-size: 16px;
}
.floatMenu img{
 transition: transform 0.3s ease; /* 添加过渡效果 */
}

.floatMenu img:hover {
  transform: scale(1.1); /* 鼠标悬停时放大 1.1 倍 */
}
</style>
<template>
<div class="qrCode">
      <img src="@/assets/images/qrcode.png" alt="" srcset="">
      <p>微信扫码 咨询帮助</p>
    </div>
    <div class="floatMenu">

      <div style="border-bottom: 1px solid #E6E6E6;" @click="this.$router.push({path:'/me'})">
        <img src="@/assets/images/ic_home_cuotiji@2x.png" style="width: 80%;" alt="" srcset="" >
        <p>错题集</p>
      </div>
      <div style="border-bottom: 1px solid #E6E6E6;" @click="this.$router.push({path:'/me/myIndex'})">
        <img src="@/assets/images/ic_home_chengji@2x.png" alt="" style="width: 80%; margin-top: 10px" srcset="">
        <p>成 绩</p>
      </div>
      <div  @click="scrollToTop">
        <VerticalAlignTopOutlined style="font-size: 40px;margin-top: 20px;" />
      </div>
      
    </div>

</template>
<script>
import {  VerticalAlignTopOutlined } from '@ant-design/icons-vue';
export default {
  name: 'FloatMenu',
  components: {  VerticalAlignTopOutlined },
  methods: {
        scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // 平滑滚动
        });
        },
    }
}

</script>